import { CreateOpeningHoursFormValues } from "../openingHoursTypes"
import { WeeklySchedule } from "../../../../../../../supplier/admin/merchant/merchants/supplierMerchantsTypes"

export const convertToOpeningHours = (weeklySchedule: CreateOpeningHoursFormValues): WeeklySchedule[] => {
    const daysMap = [
        { weekDayNumber: 1, weekDay: "MONDAY", key: "monday" },
        { weekDayNumber: 2, weekDay: "TUESDAY", key: "tuesday" },
        { weekDayNumber: 3, weekDay: "WEDNESDAY", key: "wednesday" },
        { weekDayNumber: 4, weekDay: "THURSDAY", key: "thursday" },
        { weekDayNumber: 5, weekDay: "FRIDAY", key: "friday" },
        { weekDayNumber: 6, weekDay: "SATURDAY", key: "saturday" },
        { weekDayNumber: 7, weekDay: "SUNDAY", key: "sunday" },
    ]

    return daysMap.reduce((result: WeeklySchedule[], { weekDayNumber, weekDay, key }) => {
        const daySchedule = weeklySchedule[key as keyof CreateOpeningHoursFormValues]
        if (daySchedule.isOpen) {
            result.push({
                weekDayNumber,
                weekDay,
                hours: {
                    open: daySchedule.open ? daySchedule.open.toFormat("HH:mm") : "",
                    close: daySchedule.close ? daySchedule.close.toFormat("HH:mm") : "",
                },
            })
        }
        return result
    }, [])
}
